export interface IFilterInscription {
  Id?: number | null;
  Email?: string;
  RaisonSociale?: string;
  NomPrenom?: string;
  Siren?: string;
  IdsEtatDemandeInscription?: number[];
  SortField?: string;
  IsDescending?: boolean;
  Limit?: number;
  Offset?: number;
}

export const getDefaultFilterInscription = (): IFilterInscription => {
  return {
    Id: null,
    Email: "",
    RaisonSociale: "",
    NomPrenom: "",
    Siren: "",
    IdsEtatDemandeInscription: [],
    SortField: "",
    IsDescending: false,
    Limit: 10,
    Offset: 0,
  };
};
